import { defineWidget } from '../widget-types';

export const staticCategoriesWidget = defineWidget({
  type: 'static-categories',
  schema: {
    label: 'Static Categories',
    description: 'Text-based category navigation list',
    props: {},
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
    },
    dataDeps: [],
  },
  nameTh: 'หมวดหมู่แบบข้อความ',
  descriptionTh: 'รายการหมวดหมู่สินค้าแบบข้อความ',
  category: 'navigation',
  thumbnail: '/widget-thumbnails/static-categories.svg',
  defaults: {
    type: 'static-categories',
    props: {},
    slots: {
      heading: { value: 'Categories' },
    },
  },
});
